import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { ClaimStatus } from 'src/app/core/enums/claim-status.enum';
import { Pagination } from 'src/app/core/interfaces/pagination.interface';
import { ClaimFilterModel } from 'src/app/features/claims/data/models/claim-filter.model';

@Component({
  selector: 'app-claims-tables',
  templateUrl: './claims-table.component.html',
  styleUrls: ['./claims-table.component.css'],
})
export class ClaimsTablesComponent {
  @Input() userClaims?: any;
  @Input() pagination!: Pagination;
  @Input() skeleton?: boolean;
  @Input() isPluri?: boolean;
  @Input() filterKey?: string;
  @Input() haveResults: boolean = true;
  @Output() pageChanged = new EventEmitter<any>();
  @Output() filters = new EventEmitter<ClaimFilterModel>();
  @Output() cancel = new EventEmitter<void>();

  public skeletons: any = [{}, {}, {}, {}, {}];

  public onFilterKey?: string;
  public claim: any;

  constructor(private router: Router) {}
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterKey'] && changes['filterKey'].currentValue) {
      this.onFilterKey = this.filterKey;
    }
    if (changes['userClaims'] && changes['userClaims'].currentValue) {
      this.claim = this.userClaims;
    }
  }

  getClassForRole(rol: string): string {
    switch (rol) {
      case 'Trabajador':
        return 'status-pending';
      case 'Empleador':
        return 'status-audience-set';
      case 'Representante gremial':
        return 'status-admited';
      default:
        return '';
    }
  }

  changePage(event: any) {
    this.pagination.actualPage = event.page + 1;
    this.pagination.itemsPerPage = event.rows;
    this.pageChanged.emit();
  }

  view(selectedClaimId: number) {
    this.router.navigate(['/main/claims', selectedClaimId]);
  }

  onFiltersApplied(event: ClaimFilterModel) {
    this.filters.emit(event);
  }

  onFilterCancel() {
    this.cancel.emit();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case ClaimStatus.DRAFT:
        return 'status-draft';
      case ClaimStatus.PENDING:
        return 'status-pending';
      case ClaimStatus.REFUSED:
        return 'status-refused';
      case ClaimStatus.FINALIZED:
        return 'status-finalized';
      case ClaimStatus.IN_INTERNAL_PROCESS:
        return 'status-in-internal-process';
      case 'Tramite Interno':
        return 'status-in-internal-process';
      case 'En trámite interno':
        return 'status-in-internal-process';
      case ClaimStatus.AUDIENCE_SET:
        return 'status-audience-set';
      case 'Audiencia fijada':
        return 'status-audience-set';
      case ClaimStatus.ADMITTED:
        return 'status-admited';
      default:
        return '';
    }
  }
}
